import { Artifact } from "../../models";

import DesignRow from "./DesignRow";

type Props = {
  artifacts: Artifact[];
  onClick: (artifact: Artifact) => void;
};

const DesignTable = ({ artifacts, onClick }: Props): JSX.Element => (
  <>
    {artifacts.map((artifact) => (
      <DesignRow
        key={artifact.id}
        artifact={artifact}
        onClick={() => onClick(artifact)}
      />
    ))}
  </>
);

export default DesignTable;
